/**
 * @file components/biz/common/dialogCommonAction.js
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import _ from 'lodash';

import {createPayload} from '../../common/helper';
import {DialogOption} from '../index';

export function dialogCommonAction(dialogOption: DialogOption, payload: any) {

    const {className, width, title, maskClosable, body, foot, mask} = dialogOption;
    const {cancelWithSuccess, okText, cancelText, fromTable = false} = dialogOption;
    const $title = _.template(title)(payload);

    const {$payloadFields, $extraPayload, content, $onBeforeDialogOpen} = body;
    payload = createPayload(payload, $payloadFields, $extraPayload);
    // dialog打开前通过$onBeforeDialogOpen钩子来修改输入数据
    payload = typeof $onBeforeDialogOpen === 'function'
        ? ($onBeforeDialogOpen(payload) || payload) : payload;

    const dialogInfo = {
        dialogType: 'common',
        className,
        title: $title,
        width,
        maskClosable,
        foot,
        okText,
        cancelText,
        cancelWithSuccess,
        payload,
        wrappedComponent: content,
        fromTable,
        mask
    };
    return dialogInfo;
}
